<template>
  <div>
    <!-- 悬浮按钮 - 添加定位样式 -->
    <div
      class="custom-tel fixed size-[11.73vw] rounded-full bg-white flex justify-center items-center cursor-pointer"
      :style="{ right: right + 'px', bottom: bottom + 'px' }"
      @click="centerDialogVisible = true"
    >
      <el-icon class="el-icon-phone text-[6vw]" />
    </div>

    <el-dialog
      title="联系电话"
      :visible.sync="centerDialogVisible"
      width="90%"
      center
    >
      <span class="flex justify-center font-harmony font-bold text-[3.73vw]"
        >400 0336 691
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button-group class="flex justify-center w-full">
          <el-button
            class="w-full text-[3.73vw]"
            @click="centerDialogVisible = false"
            >取 消<i class="el-icon-close ml-[2vw]"></i
          ></el-button>
          <el-button
            class="w-full text-[#05358C] text-[3.73vw]"
            @click="handleCall"
            >拨 打<i class="el-icon-phone-outline ml-[2vw]"></i
          ></el-button>
        </el-button-group>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "mobile_Tel",
  props: {
    visibilityHeight: {
      type: Number,
      default: 0,
    },
    right: {
      type: Number,
      default: window.innerWidth * 0.06,
    },
    bottom: {
      type: Number,
      default: window.innerWidth * 0.48,
    },
  },

  data() {
    return {
      centerDialogVisible: false,
      phoneNumber: "400 0336 691", // 存储电话号码
    };
  },
  methods: {
    handleCall() {
      // 关闭对话框
      this.centerDialogVisible = false;
      // 处理电话号码格式（移除横线）
      const telNumber = this.phoneNumber.replace(/-/g, "");
      // 唤起拨号界面
      window.location.href = `tel:${telNumber}`;
    },
  },
};
</script>

<style scoped>
/* 悬浮按钮样式 */
.custom-tel {
  background: #ffffff;
  color: #05358c;
  z-index: 49;
  transition: all 0.3s;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}

/* 悬浮按钮悬停样式 */
.custom-tel:active {
  background: #9ca3af;
  transform: scale(1.1);
}

::v-deep .el-dialog__title {
  font-size: 3.73vw;
  font-family: "HarmonyOS Sans SC";
  color: #1a2233;
  font-weight: normal;
}

::v-deep .el-dialog__close {
  display: none !important;
}
</style>